import { BaseQuestionField } from './components/BaseQuestionField';
import { useQuestionField } from './hooks/useQuestionField';

export const QuestionField: React.FC = () => {
	const {
		data: { parent, questions },
	} = useQuestionField();

	if (!parent || !questions.length) return null;

	return (
		<div className="flex flex-col gap-6">
			{questions.map((question, idx) => (
				<BaseQuestionField key={question.name} parent={parent} question={question} idx={idx + 1} />
			))}
		</div>
	);
};
